var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputNumber",class:[
    { focus: _vm.active },
    { disabled: _vm.inputAttributes.disabled } ]},[(_vm.active)?_c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.inputAttributes,false),_vm.inputListeners)):_c('input',_vm._b({attrs:{"type":"text"},domProps:{"value":_vm.displayValue},on:{"click":_vm.onClick,"mousedown":_vm.onMouseDown}},'input',_vm.inputAttributes,false))])}
var staticRenderFns = []

export { render, staticRenderFns }